export default __webpack_public_path__ + "static/media/c.7072b98c.svg";